import { useState } from "react";
import { importFieldError, type ImportFieldError } from "@/lib/import-field-validation";
import { useProfileMergeStore } from "@/stores/profile-merge-store";

// Layer-2 sibling of useDateFieldWarning: decides when an in-line merge field's length/email/phone
// warning shows, and returns the handlers to wire to the input. The warning appears once the user
// LEAVES the field (onBlur) or the bar reveals all errors on a blocked save — never mid-keystroke.
// `validate` is false when this value would not be committed (the discarded side, or an unedited
// existing side), so no warning nags on it. Shares the store's reveal flag with the date warnings so
// a single blocked save surfaces every kind of error at once. Pairs with <MergeFieldWarning>.
export function useImportFieldWarning(
  fieldKey: string,
  value: string,
  validate: boolean,
): { error: ImportFieldError | null; onBlur: () => void; onEdit: () => void } {
  const reveal = useProfileMergeStore((s) => s.revealDateErrors);
  const [blurred, setBlurred] = useState(false);
  const [editing, setEditing] = useState(false);
  const err = validate ? importFieldError(fieldKey, value) : null;
  return {
    error: err && !editing && (blurred || reveal) ? err : null,
    onBlur: () => {
      setEditing(false);
      setBlurred(true);
    },
    onEdit: () => setEditing(true),
  };
}
